var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return !_vm.userIsGuest
    ? _c(
        "v-tooltip",
        {
          key: "3",
          staticClass: "text-center",
          attrs: { top: "" },
          scopedSlots: _vm._u(
            [
              {
                key: "activator",
                fn: function ({ on, attrs }) {
                  return [
                    _c(
                      "v-btn",
                      _vm._g(
                        _vm._b(
                          {
                            staticClass: "ma-0 pa-0 btnCanvas",
                            staticStyle: {
                              background: "transparent !important",
                              "pointer-events": "all",
                            },
                            attrs: { rounded: "", elevation: "0", medium: "" },
                            on: {
                              click: function ($event) {
                                _vm.profileOpen = true
                                _vm.currentTab = "tab-history"
                              },
                            },
                          },
                          "v-btn",
                          attrs,
                          false
                        ),
                        on
                      ),
                      [
                        _c(
                          "v-icon",
                          { attrs: { large: "", fab: "", color: "primary" } },
                          [_vm._v("history")]
                        ),
                      ],
                      1
                    ),
                  ]
                },
              },
            ],
            null,
            false,
            528331321
          ),
        },
        [
          _vm._v(
            " " +
              _vm._s(_vm._f("capitalize")(_vm.$t("message.storico_ordini"))) +
              " "
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }